import axiosInstance from "auth/FetchInterceptor";
import { XIN_THOI_VIEC_API } from "constants/ApiConstant";
const xinThoiViectService = {};

xinThoiViectService.create = function (data) {
  return axiosInstance.post(`${XIN_THOI_VIEC_API}`, data);
};

xinThoiViectService.update = function (data) {
  return axiosInstance.put(`${XIN_THOI_VIEC_API}`, data);
};

xinThoiViectService.delete = function (id) {
  return axiosInstance.delete(`${XIN_THOI_VIEC_API}?id=${id}`);
};

xinThoiViectService.getbyid = function (id) {
  return axiosInstance.get(`${XIN_THOI_VIEC_API}?id=${id}`);
};
xinThoiViectService.search = function (data) {
  return axiosInstance.post(`${XIN_THOI_VIEC_API}/search`,data);
};


export default xinThoiViectService;
